import { IconFilters16, UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './MobileFiltersButton.css';

interface IMobileFiltersButtonProps {
  onClick(): void;
}

export const MobileFiltersButton: React.FC<IMobileFiltersButtonProps> = ({ onClick }) => {
  return (
    <button onClick={onClick} className={styles['button-container']}>
      <div className={styles['button']}>
        <IconFilters16 color="primary_100" />
        <UIHeading5 color="primary_100">Фильтры</UIHeading5>
      </div>
    </button>
  );
};
